/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
} from './Person';

/**
 * Player with their current team assignment (if any)
 * @export
 * @interface UserPlayer
 */
export interface UserPlayer {
    /**
     * 
     * @type {string}
     * @memberof UserPlayer
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UserPlayer
     */
    playerNumber?: number | null;
    /**
     * 
     * @type {Person}
     * @memberof UserPlayer
     */
    person?: Person;
    /**
     * ID of team the player is currently assigned to
     * @type {string}
     * @memberof UserPlayer
     */
    teamId?: string | null;
    /**
     * Name of team the player is currently assigned to
     * @type {string}
     * @memberof UserPlayer
     */
    teamName?: string | null;
    /**
     * Email of user who created this player
     * @type {string}
     * @memberof UserPlayer
     */
    createdBy?: string;
}

/**
 * Check if a given object implements the UserPlayer interface.
 */
export function instanceOfUserPlayer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserPlayerFromJSON(json: any): UserPlayer {
    return UserPlayerFromJSONTyped(json, false);
}

export function UserPlayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPlayer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
        'person': !exists(json, 'person') ? undefined : PersonFromJSON(json['person']),
        'teamId': !exists(json, 'teamId') ? undefined : json['teamId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
    };
}

export function UserPlayerToJSON(value?: UserPlayer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'playerNumber': value.playerNumber,
        'person': PersonToJSON(value.person),
        'teamId': value.teamId,
        'teamName': value.teamName,
        'createdBy': value.createdBy,
    };
}

